<dl class="m-0 grid grid-cols-2 overflow-hidden rounded-xl border border-border bg-card shadow-sm lg:grid-cols-4"
    [attr.aria-busy]="loading() ? 'true' : null">

    <div class="border-b border-border px-5 py-4 lg:border-b-0 lg:border-r">
        <dt class="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.07em] text-muted-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="M18 21a8 8 0 0 0-16 0" />
                <circle cx="10" cy="8" r="5" />
                <path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" />
            </svg>
            Creators screening
        </dt>
        <dd class="m-0 mt-1.5 font-heading text-[32px] font-extrabold leading-none tracking-[-0.025em] text-foreground">
            {{ results.kpis().creators }}
        </dd>
    </div>

    <div class="border-b border-border px-5 py-4 lg:border-b-0 lg:border-r">
        <dt class="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.07em] text-muted-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <rect width="18" height="18" x="3" y="3" rx="2" />
                <path d="M7 3v18" />
                <path d="M3 7.5h4" />
                <path d="M3 12h18" />
                <path d="M3 16.5h4" />
                <path d="M17 3v18" />
                <path d="M17 7.5h4" />
                <path d="M17 16.5h4" />
            </svg>
            Content evaluated
        </dt>
        <dd class="m-0 mt-1.5 font-heading text-[32px] font-extrabold leading-none tracking-[-0.025em] text-foreground">
            {{ results.kpis().evaluated }}
            <small class="ml-1.5 font-sans text-[13px] font-semibold tracking-normal text-muted-foreground">of {{
                results.kpis().totalContent }}</small>
        </dd>
    </div>

    <div class="border-b border-border px-5 py-4 lg:border-b-0 lg:border-r">
        <dt class="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.07em] text-muted-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                <line x1="4" x2="4" y1="22" y2="15" />
            </svg>
            Red flags raised
        </dt>
        <dd class="m-0 mt-1.5 font-heading text-[32px] font-extrabold leading-none tracking-[-0.025em]"
            [class]="results.kpis().flags > 0 ? 'text-red-500 dark:text-red-400' : 'text-foreground'">
            {{ results.kpis().flags }}
            @if (flagSuffix(); as suffix) {
            <small class="ml-1.5 font-sans text-[13px] font-semibold tracking-normal text-muted-foreground">{{ suffix
                }}</small>
            }
        </dd>
    </div>

    <div class="px-5 py-4">
        <dt class="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.07em] text-muted-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="m12 14 4-4" />
                <path d="M3.34 19a10 10 0 1 1 17.32 0" />
            </svg>
            Cohort completion
        </dt>
        <dd class="m-0 mt-1.5 font-heading text-[32px] font-extrabold leading-none tracking-[-0.025em] text-foreground">
            {{ results.kpis().cohortCompletion }}%
        </dd>
    </div>
</dl>

@if (results.cohortTruncated()) {
<p class="mt-2 text-[11px] text-muted-foreground">
    Showing the first 200 creators on this brief — the totals above cover those only.
</p>
}
